import React from 'react';

import { queryParamsModule } from '@/modules/queryParams';

import type { IWizard } from 'use-wizard/lib/cjs/useWizard/types/IWizard';

const STEP_PARAM = 'step';

export const useInitializeSteps = (
  wizard: IWizard,
  layoutStepsKeys: string[],
) => {
  React.useEffect(() => {
    const stepFromParams = queryParamsModule.getParam(STEP_PARAM);
    const firstStep = layoutStepsKeys[0];

    // If no step in params, do nothing
    if (!stepFromParams) {
      console.info('Steps info: No step in params, doing nothing');
      return;
    }

    const stepIndex = layoutStepsKeys.indexOf(stepFromParams);

    // If invalid step, go to first step
    if (stepIndex === -1) {
      wizard.goToStep(firstStep);
      queryParamsModule.setParam(STEP_PARAM, firstStep);
      console.info('Steps info: Invalid step, going to first step');
      return;
    }

    // If valid step, initialize wizard with step from params
    const prevSteps = layoutStepsKeys.slice(0, stepIndex);
    wizard.history.push(...prevSteps, stepFromParams);
    wizard.goToStep(stepFromParams);
    queryParamsModule.setParam(STEP_PARAM, stepFromParams);
    console.info('Steps info: Valid step, going to step from params');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
